import { ClientEnvironment, FooterNavigation } from '@thehubz/client/core';

export const footerConfig = (env?: ClientEnvironment): FooterNavigation[] => {
  return [
    {
      navLink: [env?.brandConfig?.navigation?.imprintUrl ?? '/content/imprint'],
      navText: $localize`:footer navigation:Imprint`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.privacyUrl ?? '/content/privacy'],
      navText: $localize`:footer navigation:Privacy`,
    },
    {
      navLink: [env?.brandConfig?.navigation?.supportUrl ?? '/content/support'],
      navText: $localize`:footer navigation:Support`,
    },
  ];
};
